export const TopicDiscoveryWidgetType = {
  ChinaScienceDiscovery: "china-science-discovery",
  HundredTopTables: "100-top-tables",
  OpenQuestionsSeriesDiscovery: "open-questions-series-discovery",
  PostMagazine: "post-magazine",
  RecommendedForYou: "recommended-for-you",
} as const;
